@switch (rule()) {
  @case ('SPLIT_AFTER_MULTITEKEN_KLANK') {
    <div class="flex gap-12">
      @for (strokes of ['II', 'III', 'IIII']; track strokes) {
        <div class="flex items-end gap-3">
          <span class="border-b-2 border-current px-1 leading-none">{{ strokes }}</span>
          <span>/</span>
          <span class="w-10 border-b-2 border-current"></span>
        </div>
      }
    </div>
  }
  @case ('SPLIT_BEFORE_CENTRAL_CONSONANT') {
    <div class="flex items-end gap-3">
      <span class="w-10 border-b-2 border-current"></span>
      <span>/</span>
      <span class="grid w-10 place-items-center border-b-2 border-current pb-1">
        <span class="size-5 bg-current"></span>
      </span>
    </div>
  }
  @case ('SPLIT_BETWEEN_CONSONANTS') {
    <div class="flex items-end gap-3">
      <span class="grid w-10 place-items-center border-b-2 border-current pb-1">
        <span class="size-5 bg-current"></span>
      </span>
      <span>/</span>
      <span class="grid w-10 place-items-center border-b-2 border-current pb-1">
        <span class="size-5 bg-current"></span>
      </span>
    </div>
  }
}
